module.exports = __webpack_public_path__ + "img/83.6e287aa8.jpg";